/**
 * 스크립트 호스트 싱글턴(결정 #4/#6). 언어별 라우터(QuickJS=JS, wasmoon=Lua)를
 * 전역에서 공유한다. UI/액션은 core의 ScriptHost 인터페이스로만 다룬다(결정 #10).
 * 각 엔진 WASM은 해당 언어 스크립트가 처음 load될 때만 lazy import된다.
 *
 * 중개 fetch 브로커(결정 #17)도 함께 둔다. core 정화 정책을 통과한 요청만 실제
 * 호출하며, 스크립트는 raw fetch를 절대 받지 못한다.
 */
import type { FetchBroker, ScriptHost } from "@roqeet/core";
import { CompositeScriptHost, WebFetchBroker } from "../platform/script/index.js";

export const scriptHost: ScriptHost = new CompositeScriptHost();
export const fetchBroker: FetchBroker = new WebFetchBroker();
